import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import axios from "axios";

const InstituteAuthContext = createContext(null);

export const InstituteAuthProvider = ({ children }) => {
  const [instituteUser, setInstituteUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/auth/institute-session`,
          { withCredentials: true }
        );
        if (isMounted && res.data?.success) {
          setInstituteUser(res.data.user);
        }
      } catch (_) {
        // no institute session
      } finally {
        if (isMounted) setLoading(false);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, []);

  const loginInstitute = async (email, password) => {
    const res = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/auth/institute-login`,
      { email, password },
      { withCredentials: true }
    );
    if (res.data?.success) {
      // Cookie is set by server
      // Make sure to extract user data consistently
      const userData = {
        id: res.data.id,
        email: res.data.email,
        name: res.data.name,
        type: res.data.type,
      };
      setInstituteUser(userData);
      return res.data;
    }
    throw new Error(res.data?.message || "Institute login failed");
  };

  const logoutInstitute = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/auth/institute-logout`,
        {},
        { withCredentials: true }
      );
    } catch (_) {
      // ignore
    } finally {
      setInstituteUser(null);
    }
  };

  const value = useMemo(
    () => ({
      instituteUser,
      setInstituteUser,
      loading,
      loginInstitute,
      logoutInstitute,
    }),
    [instituteUser, loading]
  );

  return (
    <InstituteAuthContext.Provider value={value}>
      {children}
    </InstituteAuthContext.Provider>
  );
};

export const useInstituteAuth = () => useContext(InstituteAuthContext);
